import './index.css';
import { useRef, useEffect } from 'react';

const useTimer = (timeout, runner, tickCallback, paused) => {
    const cachedTimeout = useRef(timeout);
    const cachedRunner = useRef(runner);
    const cachedTickCallback = useRef(tickCallback);
    const remainingTime = useRef(timeout);
    useEffect(() => {
        if (timeout !== cachedTimeout.current) {
            remainingTime.current = timeout;
        }
        const end = Date.now() + remainingTime.current;
        let cleanupFunc;
        const nextTickFunc = () => {
            const now = Date.now();
            cachedTickCallback.current((end - now) / timeout);
            remainingTime.current = end - now;
            if (now > end) {
                return;
            }
            cleanupFunc = cachedRunner.current(nextTickFunc);
        };
        if (!paused) {
            nextTickFunc();
        }
        return () => {
            cleanupFunc?.();
        };
    }, [timeout, paused]);
};

export { useTimer };
//# sourceMappingURL=useTimer.js.map
